import ArgumentAssertionBuilder from '../Assertions/ArgumentAssertionBuilder';
import ArrayLikeArgumentAssertionBuilder from '../Assertions/ArrayLikeArgumentAssertionBuilder';
import CompareAssertionBuilder from '../Assertions/CompareAssertionBuilder';
import GuidArgumentAssertionBuilder from '../Assertions/GuidArgumentAssertionBuilder';
import StringArgumentAssertionBuilder from '../Assertions/StringArgumentAssertionBuilder';
import NotSupportedException from '../Exceptions/NotSupportedException';
import Guid from '../Guid';
import isComparable from '../TypeHelpers/isComparable';
export default function ensure(argument, argumentName) {
    if (argument instanceof Guid) {
        return new GuidArgumentAssertionBuilder(argument, argumentName);
    }
    else if (Array.isArray(argument)) {
        return new ArrayLikeArgumentAssertionBuilder(argument, argumentName);
    }
    else if (typeof (argument) === "string") {
        return new StringArgumentAssertionBuilder(argument, argumentName);
    }
    else if (typeof (argument) === "object") {
        return new ArgumentAssertionBuilder(argument, argumentName);
    }
    else if (isComparable(argument)) {
        return new CompareAssertionBuilder(argument, argumentName);
    }
    else {
        throw new NotSupportedException("the argument type is not supported");
    }
}
